import axios from "axios";
import { url } from "./utils/url";
import authHeader from "./utils/auth-header";

class LocationApi {
  static async getAll(id: any) {
    const result = await axios.get(`${url}/admin/location/${id}`, {
      headers: authHeader(),
    });
    return result.data;
  }

  static async getOne(id: any) {
    const result = await axios.get(`${url}/admin/location/one/${id}`, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async delete(id: any) {
    const result = await axios.delete(`${url}/admin/location/${id}`, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async create(id: any, body: any) {
    const result = await axios.post(`${url}/admin/location/${id}`, body, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async update(id: any, body: any) {
    const result = await axios.put(`${url}/admin/location/${id}`, body, {
      headers: authHeader(),
    });

    return result.data;
  }
}

export default LocationApi;
